const es = {
  nav: {
    services: 'Servicios',
    about: 'Sobre nosotros',
    references: 'Proyectos',
    contact: 'Contacto',
    cta: 'Hola! →',
  },
  hero: {
    kicker: 'Studio de Diseño & Texto',
    tagline: 'Porque con nosotros tienes tiempo para lo que importa',
    cta1: 'Hablemos →',
    cta2: 'Nuestros Servicios',
    marquee: 'buen diseño y texto para ti de buenas  ·  ',
  },
  intro: {
    kicker: '#bettertogether',
    h2line1: 'Studio de Diseño & Texto',
    h2line2: '',
    subheadline: 'good. better. buenas.',
    p1: 'Somos Eva · diseñadora gráfica, Christina · redactora y Agustín · gurú IT. Y un equipo de experimentados expertos en tecnología y marketing online. Amamos el diseño, las palabras y la tecnología. El mundo digital y la vida analógica. Escribimos textos que venden, diseñamos y programamos branding y diseño web impactante, contenido para redes sociales, anuncios y productos impresos. Para todos los que buscan lo especial.',
    p2: '',
    p3: '',
    button: 'Más sobre nosotros →',
  },
  services: {
    kicker: '#buenasideas',
    h2: 'Lo que hacemos',
    intro:
      'Combinamos diseño gráfico, texto y tecnología. Juntos creamos experiencias de marca y cliente extraordinarias. Desarrollamos, diseñamos y programamos productos y plataformas digitales y analógicas que además tienen muy buena pinta. Desde la única revista impresa hasta el diseño web moderno y el software específico – individual, creativo y profesional.',
    col1: {
      title: 'Diseño Gráfico',
      items: [
        'Identidad Corporativa',
        'Diseño Corporativo',
        'Diseño de Logo',
        'Diseño Web, App y Pantalla',
        'Diseño Editorial e Impresión',
        'Revistas y Folletos',
        'Diseño de Anuncios y Contenido',
        'Diseño de Packaging',
      ],
      link: 'Saber más →',
    },
    col2: {
      title: 'Textos & Palabras',
      items: [
        'Comunicación Corporativa',
        'Textos Web y App',
        'Storytelling',
        'Textos Publicitarios y de Revista',
        'Textos de Anuncios y Campañas',
        'Content Marketing',
        'Eslóganes y Claims',
        'Textos SEO',
      ],
      link: 'Saber más →',
    },
    col3: {
      title: 'Software & Desarrollo',
      items: [
        'Desarrollo Mobile, Web y App',
        'Productos y Plataformas Digitales',
        'Desarrollo de Software',
        'Diseño Responsive',
        'Landing Pages',
        'Sitios Web Corporativos',
        'Interfaces y Bases de Datos',
        'E-Commerce y Tiendas Online',
      ],
      link: 'Saber más →',
    },
    panel:
      'Desarrollo de Marca · Branding · Packaging · Print y Digital · Diseño Web · IA y Software · Social Media · Content Marketing · Paid Advertising',
  },
  team: {
    kicker: '#buenaspersonas',
    h2: 'Quiénes somos',
    moreLabel: 'saber más',
    lessLabel: 'menos',
    intro:
      'We are young, wild and free – bueno, ya no somos tan jóvenes. Pero al menos todavía nos sentimos así. Somos un grupo de creativos que aman lo que hacen. La agencia algo diferente, donde cada uno es experto en su campo. Somos valientes, motivados y experimentados. Creativos analógicos y digitales. Geeks adorables. Buenas Personas. Puedes contratarnos individualmente o como equipo. Online y siempre personal.',
    eva: {
      role: 'Diseñadora Gráfica',
      bio: 'Si necesitas una imagen visual impactante con logo y concepto de color: Eva es nuestra experta en gráfica y diseño. Desarrolla y mejora tu diseño corporativo y web, tus medios impresos y online así como tu diseño de packaging. Le encantan los diseños limpios, reducidos y elegantes.',
      more: 'Eva es la hermana gemela de Christina, está casada con su amor de juventud y vive con su gata "Happy" en Hard, a orillas del hermoso lago de Constanza. Viajar es una de sus pasiones, al igual que el pádel, el yoga, el arte y la cultura. Tiene una capacidad especial para escuchar y conectar con las personas. Gracias a ello, crea diseños únicos que encajan perfectamente contigo y con tus productos y tecnologías.',
      badge: 'buen diseño by eva',
      quote: '»El buen diseño es el mínimo diseño posible«',
    },
    christina: {
      role: 'Redactora',
      bio: 'Cuando te faltan las palabras y necesitas textos inspiradores y auténticos: Christina es periodista y redactora de formación. Lleva más de 15 años en la industria del marketing y la comunicación y se independizó hace más de 5 años. Escribe textos y conceptos que emocionan y le apasionan tus historias.',
      more: 'Christina es una pensadora creativa, viajera y una persona que mira más allá. La andorrana por elección es divertida, tranquila y un poco #crazy. Le gusta el estilo de vida del sur, la comida mediterránea, pero también la comodidad austriaca. Se mueve mucho – jugando pádel, yoga, senderismo o esquí. Ahí es donde encuentra inspiración e ideas para escribir.',
      badge: 'buen texto by christina',
      quote: '»Escribir es magia hecha visible«',
    },
    agustin: {
      role: 'Desarrollador de Software',
      bio: 'Si necesitas una web o software: Agustín es nuestro Senior Full-Stack Developer. Se ocupa de tu back- y front-end y domina herramientas de IA así como todos los lenguajes de programación. También es experto en ciberseguridad. En su formación gráfica inicial aprendió lo que importa en diseño y usabilidad.',
      more: 'Agus no conoce los problemas, siempre piensa en soluciones. Es argentino y español, vive en Andorra y cuando no está programando con nuestros otros desarrolladores, lo encuentras en su bicicleta de carreras o en la pista de pádel. Le encantan las cosas sencillas de la vida: deporte, pizza, pasta, helado, café, sol, cumbia y por supuesto la bebida nacional de Argentina, su mate.',
      badge: 'buenas soluciones by agus',
      quote: '»No busques errores, busca soluciones«',
    },
    belowCards:
      '… y nuestro equipo de experimentados <strong>expertos en tecnología</strong> y <strong>marketing online</strong>, repartidos por todo el mundo. Online, pero siempre personal.',
  },
  quote: {
    text: '»Siempre hay una solución. Encuentra una, crea una o pregunta a otros por una.«',
    author: '— Tom Bilyeu',
    cta: 'Déjanos encontrar tu solución →',
  },
  referenzen: {
    kicker: '#buenasprojects',
    h2: 'Con quién trabajamos',
    intro:
      'Trabajamos con una gran variedad de empresas, autónomos, agencias y creativos de los más diversos sectores. No pensamos en compartimentos estancos, sino que estamos abiertos a lo nuevo. Pero también a lo probado, las ideas disruptivas y el pensamiento sostenible. Siguiendo el lema: si puedes imaginarlo, puedes hacerlo. Para empresas, marcas, hoteles, industria y lifestyle.',
    moreLink: 'Más Proyectos',
    lessLink: 'Mostrar menos',
    badge: 'Con Winder&Wild',
    placeholder:
      'Nuestras referencias y proyectos llegarán pronto. Habrá más. (Spoiler: Va a ser bastante BUENAS.)',
    projects: [
      {
        name: 'Hotel Birkenhof · Oberstaufen, Allgäu',
        category: 'Brand Design · Diseño Web · Textos Web · Wording · Newsletter',
      },
      {
        name: 'Hotel Helvetia · Lindau, Bodensee',
        category: 'Brand Design · Wording · Merchandising · Brochure · Textos',
      },
      {
        name: 'Physiomed · Eislingen',
        category: 'Brand Design · Logo Design · Papelería Corporativa',
      },
      { name: 'Studio Mint · Maria Jussel', category: 'Voz de Marca · Storytelling · Textos Web' },
      {
        name: 'Damüls Faschina Tourismus',
        category: 'Magazinreihe · Interviews · Texte · Storytelling',
      },
      {
        name: 'Jean & Jacques Manufactura de Helados',
        category: 'Branding · Diseño · Packaging · Wording · Textos Web',
      },
    ],
  },
  twinPower: {
    kicker: '#goodenergy',
    h2: '¿Por qué Buenas?',
    text: 'Porque "Buenas" es más que un saludo. Representa buena energía, buenas conversaciones y buena colaboración. Así es exactamente como trabajamos. Eva, Christina, Agustín y nuestro equipo. Mentes creativas con una visión compartida: apoyamos a las empresas con buenas ideas, buen diseño y buen texto. Marcas fuertes que tienen una voz única.',
    button: '¡Hola! Escríbenos →',
  },
  newsletter: {
    kicker: '#goodnewsonly',
    h2: 'Lo mejor llega por mail',
    subtext1: 'Buenas ideas y el Buenas-feeling directo en tu bandeja de entrada.',
    subtext2: 'Escribimos sobre diseño, textos, nuevos proyectos y cosas que nos inspiran.',
    placeholder: 'Tu dirección de email',
    button: 'Suscribirme →',
    sending: 'Un momento...',
    success: '¡Ya estás dentro! Pronto recibirás noticias.',
    error: 'Ups – algo salió mal. Por favor, inténtalo de nuevo.',
    privacy: 'Al suscribirte aceptas nuestra',
    privacyLink: 'Política de privacidad',
    privacyEnd: '.',
    captchaError: 'Por favor, verifica que no eres un robot.',
  },
  kontakt: {
    kicker: '#makeitbuenas',
    h2line1: '¿Cómo podemos',
    h2line2: 'ayudarte?',
    subtext1: 'Hablemos de tu marca, tu idea o tu proyecto.',
    subtext2: 'Tomando un café. O en una llamada. O en ambos.',
    bookingKicker: '#bookwithus',
    bookingTitle: 'Reserva una llamada',
    bookingText: 'Elige el horario que mejor te venga y nos vemos por Zoom.',
    bookingButton: 'Ver disponibilidad →',
    bookingIframeTitle: 'Reserva una llamada con Buenas Studio',
    bookingOpenNewTab: 'Abrir en pestaña nueva',
    bookingClose: 'Cerrar',
    field1: 'Tu Nombre',
    field2: 'Tu Email',
    field3: 'Tu Empresa / Proyecto',
    field4: 'Cuéntanos tu idea…',
    button: 'Enviar →',
    sending: 'Enviando…',
    error: 'Vaya – algo salió mal. Escíbenos directamente a hi@buenas-studio.com.',
    captchaError: 'Por favor, verifica que no eres un robot.',
  },
  danke: {
    back: '← Volver a la página de inicio',
    kicker: '#hola!',
    title: '¡Gracias por tu mensaje!',
    text: 'Hemos recibido tu solicitud y nos pondremos en contacto contigo lo antes posible.',
    sub: 'Mientras tanto – siente libre de seguir explorando.',
  },
  impressum: {
    back: '← Volver a la página de inicio',
    title: 'Aviso Legal',
    section1: 'Información según obligación legal de información',
    taxLabel: 'Número fiscal',
    representedBy: 'Representado por',
    responsible: 'Responsable del contenido',
    disclaimer: 'Exención de responsabilidad',
    liabilityContent: 'Responsabilidad por contenidos',
    liabilityContentText:
      'Los contenidos de nuestro sitio web han sido creados con el mayor cuidado. Sin embargo, no podemos garantizar la exactitud, integridad y actualidad de los contenidos. Como proveedor de servicios, somos responsables de nuestros propios contenidos en estas páginas de acuerdo con las leyes generales aplicables.',
    liabilityLinks: 'Responsabilidad por enlaces',
    liabilityLinksText:
      'Nuestro sitio web contiene enlaces a sitios web externos de terceros sobre cuyo contenido no tenemos influencia. Por ello, no podemos aceptar ninguna responsabilidad por dicho contenido externo. El proveedor u operador respectivo de las páginas es siempre responsable del contenido de las páginas enlazadas. Las páginas enlazadas fueron comprobadas en busca de posibles infracciones legales en el momento de la vinculación. No se pudieron reconocer contenidos ilegales en el momento de la vinculación.',
    copyright: 'Derechos de autor',
    copyrightText:
      'Los contenidos y obras creados por los operadores del sitio en estas páginas están sujetos a las leyes de derechos de autor. La reproducción, procesamiento, distribución y cualquier tipo de explotación fuera de los límites de los derechos de autor requieren el consentimiento escrito del autor o creador respectivo.',
    dispute: 'Resolución de conflictos',
    disputeText:
      'No estamos dispuestos ni obligados a participar en procedimientos de resolución de conflictos ante una junta de arbitraje de consumidores.',
  },
  datenschutz: {
    back: '← Volver a la página de inicio',
    title: 'Política de Privacidad',
    date: 'Versión: Marzo 2026',
    s1h2: '1. Protección de Datos de un Vistazo',
    s1h3a: 'Notas Generales',
    s1p1: 'Las siguientes notas ofrecen una visión general sencilla de lo que sucede con sus datos personales cuando visita nuestro sitio web. Los datos personales son todos aquellos datos con los que puede ser identificado personalmente.',
    s1h3b: 'Recopilación de Datos en Nuestro Sitio Web',
    s1q1: '¿Quién es responsable de la recopilación de datos en este sitio web?',
    s1a1intro: 'El tratamiento de datos en este sitio web es realizado por el operador del sitio:',
    s1q2: '¿Cómo recopilamos sus datos?',
    s1a2: 'Sus datos se recopilan, por un lado, por usted mismo al proporcionárnoslos, por ejemplo, al rellenar nuestro formulario de contacto o al suscribirse a nuestro boletín. Otros datos se recogen automáticamente o con su consentimiento cuando visita el sitio web a través de nuestros sistemas informáticos. Estos son principalmente datos técnicos (p. ej., navegador de internet, sistema operativo u hora de acceso a la página).',
    s1q3: '¿Para qué utilizamos sus datos?',
    s1a3: 'Parte de los datos se recopila para garantizar el funcionamiento sin errores del sitio web. Otros datos pueden utilizarse para analizar su comportamiento de usuario, siempre que haya dado su consentimiento.',
    s1q4: '¿Qué derechos tiene sobre sus datos?',
    s1a4: 'Tiene derecho en todo momento a recibir información gratuita sobre el origen, el destinatario y el propósito de sus datos personales almacenados. También tiene derecho a solicitar la corrección o eliminación de estos datos. Si ha dado su consentimiento al tratamiento de datos, puede revocarlo en cualquier momento con efecto futuro.',
    s1a4b:
      'Para este y otros asuntos relacionados con la protección de datos, puede ponerse en contacto con nosotros en cualquier momento:',
    s2h2: '2. Alojamiento Web',
    s2p1: 'Nuestro sitio web está alojado por un proveedor de servicios externo (proveedor de alojamiento). Los datos personales recopilados en este sitio web se almacenan en los servidores del proveedor. Esto puede incluir direcciones IP, solicitudes de contacto, metadatos y datos de comunicación, datos contractuales, datos de contacto, nombres, accesos al sitio web y otros datos.',
    s2p2: 'El proveedor de alojamiento se utiliza con el fin de cumplir contratos con nuestros clientes potenciales y existentes y en beneficio de una provisión segura, rápida y eficiente de nuestra oferta en línea.',
    s3h2: '3. Notas Generales e Información Obligatoria',
    s3h3a: 'Protección de Datos',
    s3p1: 'El operador de estas páginas se toma muy en serio la protección de sus datos personales. Tratamos sus datos personales de forma confidencial y de acuerdo con las disposiciones legales de protección de datos aplicables, en particular la legislación andorrana de protección de datos (LQPD – Llei Qualificada de Protecció de Dades, 18/2003), así como el Reglamento General de Protección de Datos de la UE (RGPD/GDPR), cuando sea aplicable.',
    s3h3b: 'Responsable del Tratamiento',
    s3p2: 'El responsable del tratamiento es la persona física o jurídica que, sola o conjuntamente con otras, decide sobre los fines y medios del tratamiento de datos personales.',
    s3h3c: 'Período de Conservación',
    s3p4: 'A menos que se haya especificado un período de conservación más concreto en esta política de privacidad, sus datos personales permanecerán con nosotros hasta que ya no sea necesario el fin del tratamiento de datos. Si formula una solicitud legítima de eliminación o revoca su consentimiento para el tratamiento de datos, sus datos serán eliminados, salvo que tengamos otros motivos legalmente admisibles para conservar sus datos personales.',
    s3h3d: 'Sus Derechos',
    s3rights: [
      '<strong>Derecho de acceso</strong> – Puede solicitar información sobre sus datos almacenados con nosotros.',
      '<strong>Derecho de rectificación</strong> – Puede solicitar la corrección de datos incorrectos.',
      '<strong>Derecho de supresión</strong> – Puede solicitar la eliminación de sus datos («derecho al olvido»).',
      '<strong>Derecho a la limitación del tratamiento</strong> – Puede solicitar la limitación del tratamiento de sus datos.',
      '<strong>Derecho a la portabilidad de los datos</strong> – Puede solicitar que le traslademos sus datos a usted o a un tercero en formato legible por máquina.',
      '<strong>Derecho de oposición</strong> – Puede oponerse al tratamiento de sus datos personales.',
      '<strong>Derecho a retirar el consentimiento</strong> – Si el tratamiento se basa en su consentimiento, puede retirarlo en cualquier momento.',
    ],
    s3contact: 'Para ejercer estos derechos, contáctenos en:',
    s4h2: '4. Recopilación de Datos en Nuestro Sitio Web',
    s4h3a: 'Cookies',
    s4p1: 'Nuestro sitio web utiliza cookies. Las cookies son pequeños archivos de texto que su navegador almacena en su dispositivo. Las cookies nos ayudan a que nuestra oferta sea más fácil de usar, más efectiva y más segura.',
    s4types: 'Distinguimos entre:',
    s4cookies: [
      '<strong>Cookies técnicamente necesarias</strong> – Son necesarias para el funcionamiento del sitio web y no pueden desactivarse.',
      '<strong>Cookies de análisis</strong> – Nos ayudan a entender cómo interactúan los visitantes con el sitio web. Solo se activan con su consentimiento expreso.',
    ],
    s4p2: 'Cuando visita nuestro sitio web por primera vez, un banner de cookies le pedirá su consentimiento. Puede ajustar sus preferencias de cookies en cualquier momento o rechazar todas las cookies no esenciales.',
    s4h3b: 'Archivos de Registro del Servidor',
    s4logp:
      'El proveedor del sitio web recopila y almacena automáticamente información en los llamados archivos de registro del servidor, que su navegador nos transmite automáticamente. Estos incluyen:',
    s4logs: [
      'Tipo de navegador y versión del navegador',
      'Sistema operativo utilizado',
      'URL de referencia',
      'Nombre de host del equipo que accede',
      'Hora de la solicitud al servidor',
      'Dirección IP',
    ],
    s4logp2:
      'Estos datos no se combinan con otras fuentes de datos. La recopilación de estos datos se basa en intereses legítimos (Art. 6 párr. 1 lit. f RGPD): el funcionamiento técnicamente correcto del sitio web.',
    s4h3c: 'Formulario de Contacto',
    s4contactp1:
      'Si nos envía consultas a través del formulario de contacto, sus datos del formulario, incluidos los datos de contacto que haya proporcionado, serán almacenados por nosotros con el fin de tramitar la consulta y para el caso de preguntas adicionales. No compartimos estos datos sin su consentimiento.',
    s4contactp2:
      'El tratamiento de estos datos se basa en el Art. 6 párr. 1 lit. b RGPD, si su solicitud está relacionada con la ejecución de un contrato o es necesaria para la implementación de medidas precontractuales. En todos los demás casos, el tratamiento se basa en nuestro interés legítimo en la tramitación efectiva de las solicitudes que nos dirigen (Art. 6 párr. 1 lit. f RGPD) o en su consentimiento (Art. 6 párr. 1 lit. a RGPD).',
    s4storedLabel: 'Datos almacenados:',
    s4storedValue:
      'Nombre, dirección de correo electrónico, empresa/proyecto, contenido del mensaje',
    s4retentionLabel: 'Período de conservación:',
    s4retentionValue: 'Hasta la tramitación final de su consulta, máximo 3 años',
    s5h2: '5. Herramientas de Análisis',
    s5h3: 'Google Analytics',
    s5p1: 'Este sitio web utiliza Google Analytics, un servicio de análisis web proporcionado por Google Ireland Limited, Gordon House, Barrow Street, Dublín 4, Irlanda («Google»). Google Analytics utiliza cookies que permiten un análisis del uso que usted hace del sitio web.',
    s5ipLabel: 'Anonimización de IP:',
    s5ipText:
      'Hemos activado la función de anonimización de IP en este sitio web. Esto significa que su dirección IP será truncada por Google dentro de los estados miembros de la Unión Europea o en otros estados contratantes del Acuerdo sobre el Espacio Económico Europeo antes de su transmisión a EE. UU.',
    s5consent:
      'Google Analytics solo se utiliza con su consentimiento expreso a través de nuestro banner de cookies (Art. 6 párr. 1 lit. a RGPD).',
    s5contractLabel: 'Contrato de tratamiento de datos:',
    s5contractText:
      'Hemos suscrito un contrato de tratamiento de datos con Google y aplicamos íntegramente los estrictos requisitos de las autoridades de protección de datos al utilizar Google Analytics.',
    s6h2: '6. Redes Sociales',
    s6h3: 'Instagram',
    s6p1: 'Nuestro sitio web integra contenido de la red social Instagram (Meta Platforms Ireland Limited, 4 Grand Canal Square, Dublín 2, Irlanda). Cuando visita nuestra página, es posible que se establezca una conexión con los servidores de Instagram a través del contenido de Instagram integrado.',
    s6p2: 'La integración del contenido de Instagram se basa en su consentimiento (Art. 6 párr. 1 lit. a RGPD) o en la base de nuestro interés legítimo en una presentación atractiva de nuestra oferta en línea (Art. 6 párr. 1 lit. f RGPD).',
    s7h2: '7. Boletín de Noticias',
    s7p1: 'Si desea recibir el boletín ofrecido en el sitio web, necesitamos su dirección de correo electrónico y la información que nos permita verificar que usted es el propietario de la dirección de correo electrónico proporcionada y que está de acuerdo con la recepción del boletín (procedimiento de doble opt-in).',
    s7storedLabel: 'Datos almacenados:',
    s7storedValue: 'Dirección de correo electrónico, nombre (opcional), fecha de registro',
    s7purposeLabel: 'Finalidad:',
    s7purposeValue: 'Envío del boletín',
    s7legalLabel: 'Base legal:',
    s7legalValue: 'Consentimiento (Art. 6 párr. 1 lit. a RGPD)',
    s7unsubscribe:
      'Puede cancelar la suscripción al boletín en cualquier momento a través del enlace de cancelación en el boletín o enviando un correo electrónico a hi@buenas-studio.com.',
    s8h2: '8. Complementos y Herramientas',
    s8h3: 'Google Fonts',
    s8p1: 'Este sitio utiliza los denominados Web Fonts para la visualización uniforme de fuentes, que son proporcionadas por Google. Al acceder a una página, su navegador carga los Web Fonts necesarios en su caché del navegador para mostrar textos y fuentes correctamente.',
    s8p2: 'El uso de Google Web Fonts se basa en el Art. 6 párr. 1 lit. f RGPD. Tenemos un interés legítimo en la presentación uniforme del tipo de letra en nuestro sitio web.',
    s9h2: '9. Cambios en Esta Política de Privacidad',
    s9p: 'Nos reservamos el derecho de adaptar esta política de privacidad para que siempre cumpla con los requisitos legales actuales o para implementar cambios en nuestros servicios en la política de privacidad.',
    s10h2: '10. Contacto para Cuestiones de Protección de Datos',
    footernote: 'Buenas Studio · buenas-studio.com · hi@buenas-studio.com · Versión: Marzo 2026',
  },
  footer: {
    subtitle: 'Studio de Diseño & Texto',
    tagline: 'good. better. buenas.',
    locations: 'Andorra · Austria · World',
    copyright: '© 2026 Buenas Studio',
    link1: 'Aviso Legal',
    link2: 'Política de Privacidad',
  },
  whatsapp: {
    greeting: '¡Buenas!',
    text: '¿Cómo podemos ayudarte? ¡Escríbenos!',
    send: 'Enviar mensaje →',
    prefill: '¡Hola! Tengo una idea...',
  },
  seo: {
    home: {
      title: 'buenas studio – Estudio de Diseño, Texto & Software',
      description:
        'Diseño, texto y desarrollo de software desde Andorra y el Lago de Constanza. Diseño corporativo, branding, textos, sitios web y software a medida – creativo y profesional.',
    },
    legal: {
      title: 'Aviso Legal – buenas studio',
      description:
        'Aviso legal e información de la empresa buenas studio. Christina Mathis – Marketing & IT Services, Encamp, Andorra.',
    },
    privacy: {
      title: 'Política de Privacidad – buenas studio',
      description:
        'Política de privacidad de buenas studio. Información sobre la recopilación y el tratamiento de datos personales.',
    },
    thanks: {
      title: 'Gracias – buenas studio',
      description: '¡Gracias por tu mensaje! Nos pondremos en contacto contigo lo antes posible.',
    },
    notFound: {
      title: 'Página no encontrada – buenas studio',
      description: 'Esta página no existe. Vuelve a la página principal de buenas studio.',
      h1: 'Página no encontrada',
      text: 'Ups – esta página no existe.',
      back: '← Volver al inicio',
    },
  },
}

export default es
